import React, { useEffect } from 'react';
import { get } from 'lodash';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { createUseStyles } from 'react-jss';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import AdNewFormDescriptions from '../../Ads/AdNewForm/AdNewFormDescriptions';
import LoaderButton from '../../LoaderButton/LoaderButton';
import { FETCH_AD } from '../../../redux/Ads';
import { FETCH_CHANNEL_ACTIVATION } from '../../../redux/ChannelActivations';
import { CREATE_PROMOTION } from '../../../redux/Promotions';
import withScopedTranslations from '../../../withScopedTranslations/withScopedTranslations';

const MobilePromotionForm = ({ t, maxHighlights, isLoading, fetchAd, fetchChannelActivation,
                               adData, createPromotion, match: { params: { adId, channelId, }, }, }) => {
  const claesses = useStyles();
  useEffect(() => {
    fetchChannelActivation(channelId);
    fetchAd(adId);
  }, [fetchAd]);

  const [highlight_1, highlight_2] = adData?.highlights ? adData.highlights : ['', ''];

  const initialValues = (({ description, }) => (
      { description, highlight_1, highlight_2, }))(adData);

  return (
    <div>
      {adData.id &&
        <Form
          onSubmit={(values) => createPromotion({ values, adId, channelId, })}
          initialValues={initialValues}
          render={({ handleSubmit, }) => (
            <form onSubmit={handleSubmit} className={claesses.form}>
              <h2 className={claesses.title}>{t('descriptions')}</h2>
              <AdNewFormDescriptions
                formType="react-final-form"
                numberOfHighlights={maxHighlights}
              />
              <div>
                <LoaderButton
                  className={claesses.submitButton}
                  isLoading={isLoading}
                  label={t('submit')}
                />
              </div>
            </form>
          )}
        />
      }
    </div>
  );
};

const useStyles = createUseStyles({
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    marginBottom: 30,
    paddingTop: 8,
    paddingRight: 15,
    paddingBottom: 8,
    paddingLeft: 15,
    fontSize: 20,
    fontWeight: 700,
    color: '#6c6473',
    backgroundColor: '#f7f7f7',
  },
  submitButton: {
    marginBottom: 30,
    marginLeft: 15,
  },
});

MobilePromotionForm.propTypes = {
  t: PropTypes.func.isRequired,
  maxHighlights: PropTypes.number.isRequired,
  match: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  fetchAd: PropTypes.func.isRequired,
  fetchChannelActivation: PropTypes.func.isRequired,
  createPromotion: PropTypes.func.isRequired,
  adData: PropTypes.object,
};

MobilePromotionForm.defaultProps = {
  adData: {},
};

const mapStateToProps = (state) => {
  return {
    maxHighlights: get(state, ['channelActivations', 'channel_activation_data', 'max_highlights']),
    adData: get(state, ['ads', 'ad_data']),
    isLoading: get(state, ['loader', 'isLoading']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAd: (id) => dispatch(FETCH_AD(id)),
    fetchChannelActivation: (channel) => dispatch(FETCH_CHANNEL_ACTIVATION(channel)),
    createPromotion: (params) => dispatch(CREATE_PROMOTION(params)),
  };
};


export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter,
  withScopedTranslations('ad_vehicle_description')
)(MobilePromotionForm);
